// GateLoadingScreen.jsx -- onboarding `loading` / `account_error`. Single job: a quiet wait; Retry
// when the account read failed; "Try again" (reload) when loading has stalled past 10 s.
import { shell, body, ghostBtn, spacer, C } from './onboardingStyles';
export default function GateLoadingScreen({ error, stalled, onRetry, onReload }) {
  return (
    <div style={shell} aria-busy={!error}>
      <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 4, color: C.dim }}>SLIPTRACK</div>
      <div style={spacer} />
      {error && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <p style={body}>We couldn't load your account. Check your connection.</p>
          <button type="button" style={ghostBtn} onClick={onRetry}>Retry</button>
        </div>
      )}
      {!error && stalled && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <p style={body}>This is taking longer than usual.</p>
          <button type="button" style={ghostBtn} onClick={onReload}>Try again</button>
        </div>
      )}
    </div>
  );
}
